import BusinessJurisdiction from './BusinessJurisdiction' // 权限
/*原版 Role*/
/*修改版 RoleNew*/
export default BusinessJurisdiction



// WEBPACK FOOTER //
// ./src/common/components/BusinessJurisdiction/index.jsx